
const state = {
    tenantJson: null,
    menuId: 0, // 菜单id
    navPath: '/home', // 导航path    
    siteList: null,
    rightBarOpened: true,
    badgeBoxShow:false,
    totalNum:0,
    flatMenuList: [], // 平铺后的产品级菜单列表，用于权限校验
    flatSiteMenuList: {}, // 平铺后的网站级菜单列表，用于权限校验 {instanceId: [menus]}
    productMenuLoaded: false, // 产品级菜单是否已加载
    siteMenuLoadedMap: {}, // 网站级菜单加载状态 {instanceId: boolean}
    globalBusinessDialog: {
        visible: false,
        data: {}
    }
};

const getters = {
    tenantJson: state => state.tenantJson,
    token: state => state.token,
    userInfo: state => state.userInfo,
    navPath: state => state.navPath,
    menuId: state => state.menuId,
    siteList: state => state.siteList,
    currentSiteMenu: state => state.currentSiteMenu,
    rightBarOpened: state => state.rightBarOpened,
    badgeBoxShow: state => state.badgeBoxShow,
    totalNum: state => state.totalNum,
    flatMenuList: state => state.flatMenuList,
    flatSiteMenuList: state => state.flatSiteMenuList,
    productMenuLoaded: state => state.productMenuLoaded,
    siteMenuLoadedMap: state => state.siteMenuLoadedMap,
};

const mutations = {
    SET_TOTALNUM(state, totalNum){
        state.totalNum = totalNum;
    },
    SET_BADGEBOXSHOW(state, badgeBoxShow){
        state.badgeBoxShow = badgeBoxShow;
    },
    SET_RIGHTBAROPENED(state, rightBarOpened){
        state.rightBarOpened = rightBarOpened;
    },
    SET_NAV_PATH(state, status) {
        state.navPath = status;
    },
    SET_NEMU_ID(state, id) {
        state.menuId = id;
    },
    SET_TENANT_JSON: (state, tenantJson) => {
        state.tenantJson = tenantJson;
    },
    SET_TOKEN: (state, token) => {
        state.token = token;
    },
    SET_USER_INFO: (state, userInfo) => {
        state.userInfo = userInfo;
    },    
    SET_SITE_LIST: (state, siteList) => {
        // 已有数组时原地替换：default.vue 用 provide 把这个数组引用给了网站管理页，换引用它们就拿不到更新
        if (Array.isArray(state.siteList) && Array.isArray(siteList)) {
            state.siteList.splice(0, state.siteList.length, ...siteList);
            return;
        }
        state.siteList = siteList;
    },    
    SET_SITE_MENU: (state, siteMenu) => {
        state.currentSiteMenu = siteMenu;
    },
    setFlatMenuList(state, flatMenuList) {
        state.flatMenuList = flatMenuList;
        state.productMenuLoaded = true;
    },
    setFlatSiteMenuList(state, { instanceId, flatMenuList }) {
        // 使用 Vue.set 确保响应式
        if (!state.flatSiteMenuList) {
            state.flatSiteMenuList = {};
        }
        state.flatSiteMenuList[instanceId] = flatMenuList;
        
        if (!state.siteMenuLoadedMap) {
            state.siteMenuLoadedMap = {};
        }
        state.siteMenuLoadedMap[instanceId] = true;
    },
    resetMenuLoadStatus(state) {
        state.productMenuLoaded = false;
        state.siteMenuLoadedMap = {};
    },
    SET_GLOBAL_BUSINESS_DIALOG(state, payload) {
        state.globalBusinessDialog = { ...state.globalBusinessDialog, ...payload };
    }
};

const actions = {
    setTotalNum( { commit }, totalNum) {
        commit('SET_TOTALNUM', totalNum)
    },
    setBadgeBoxShow({ commit }, badgeBoxShow){
        commit('SET_BADGEBOXSHOW', badgeBoxShow)
    },
    setRightBarOpened({ commit }, rightBarOpened){
        commit('SET_RIGHTBAROPENED', rightBarOpened);
    },
    setNavPath({ commit }, path) {
        commit('SET_NAV_PATH', path);
    },    
    setMenuId({ commit }, menuId) {
        commit('SET_NEMU_ID', menuId);
    },        
    setTenantJson({ commit }, tenantJson) {
        commit('SET_TENANT_JSON', tenantJson);
    },
    setToken({ commit }, token) {
        commit('SET_TOKEN', token);
    },
    setUserInfo({ commit }, userInfo) {
        commit('SET_USER_INFO', userInfo);
    },    
    setSiteList({ commit }, siteList) {
        commit('SET_SITE_LIST', siteList);
    },
    getSiteList(store) {
        if (!Array.isArray(store.state.siteList)) return [];
        return store.state.siteList;
    },
    setSiteMenu({ commit }, siteMenu) {
        commit('SET_SITE_MENU', siteMenu);
    },
    toggleGlobalBusinessDialog({ commit }, payload) {
        commit('SET_GLOBAL_BUSINESS_DIALOG', payload);
    }
};
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
